import React, { useState, useEffect } from 'react';
import Grid from '@mui/material/Grid';
import { Document, Page } from 'react-pdf/dist/esm/entry.webpack';
import "../../../signup/contract/Pdf.css";
import DownloadIcon from '@mui/icons-material/Download';
import { Button, useTheme, useMediaQuery } from '@mui/material';
import ReactPaginate from "react-paginate";
import FormGroup from '@mui/material/FormGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from '@mui/material/Checkbox';
import ArrowLeftIcon from '@mui/icons-material/ArrowLeft';
import ArrowRightIcon from '@mui/icons-material/ArrowRight';
import AWS from 'aws-sdk';
import { awsAccessKeyID, awsSecretAccessKey, awsBucketName, awsRegion } from '../../../../constant/Constants';
import { useDispatch } from 'react-redux';
import { showAlert } from '../../../../redux/create-actions/AlertAction';
import Color from '../../../../layouts/Color';
import FontSize from '../../../../layouts/FontSize';

function getWindowDimensions() {
    const { innerWidth: width } = window;
    return {
        width
    };
}

const btnDownload = {
    background: Color.Normal,
    color: Color.Button,
    fontSize: FontSize.Tiny,
    "&:hover": {
        background: Color.Button,
        color: Color.Normal,
    },
}

export default function ContractPdf(props) {
    const theme = useTheme();
    const matchDownSM = useMediaQuery(theme.breakpoints.down('sm'));
    const matchDownMD = useMediaQuery(theme.breakpoints.down('md'));
    const [numPages, setNumPages] = useState(0);
    const [pageNumber, setPageNumber] = useState(1);
    const [, setAgree] = useState(false);
    const [windowWidth, setWindowWidth] = useState(getWindowDimensions());
    const dispatch = useDispatch();

    useEffect(() => {
        function handleResize() {
            setWindowWidth(getWindowDimensions());
        }

        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [getWindowDimensions])
    
    function onDocumentLoadSuccess({ numPages }) {
        setNumPages(numPages);
    }

    const changePage = ({ selected }) => {
        setPageNumber(selected + 1);
    };

    const handleClickAgree = (event) => {
        let value = event.target.checked;
        setAgree(value);
        props.onUpdateStep2Data({ isAgree: value });
    }

    AWS.config.update({
        accessKeyId: awsAccessKeyID,
        secretAccessKey: awsSecretAccessKey,
        region: awsRegion
    });

    const handleDownloadPdf = (s3Key) => {
        const s3 = new AWS.S3();
        let alert = {
            anchorOrigin: {
                vertical: 'top',
                horizontal: 'center'
            },
            isOpen: true,
            severity: 'error',
            title: 'Error',
            message: '',
        };
        const params = {
            Bucket: awsBucketName,
            Key: s3Key,
        };

        s3.getObject(params, (err, data) => {
            if (err) {
                alert = { ...alert, message: "Something was wrong with S3 AWS!" };
                dispatch(showAlert(alert));
            } else {
                if (data.ContentType === 'application/pdf') {
                    const blod = new Blob([data.Body], { type: 'application/pdf' });
                    const fileURL = URL.createObjectURL(blod);
                    const link = document.createElement('a');
                    link.href = fileURL;
                    link.download = s3Key;
                    link.click();
                } else {
                    alert = { ...alert, message: "Format file is not PDF!" };
                    dispatch(showAlert(alert));
                }
            }
        });
    }
    
    const renderContractPdf = (data) => {
        return data ? (
            <React.Fragment>
                <Grid item xs={12} md={12} lg={12} xl={12}>
                    <Document
                        file={data.contractPresignedUrl}
                        onLoadSuccess={onDocumentLoadSuccess}>
                        <Page width={matchDownMD ? (windowWidth.width - 150) : matchDownSM ? (windowWidth.width - 120) : null} pageNumber={pageNumber} />
                    </Document>
                    <ReactPaginate
                        pageCount={numPages}
                        onPageChange={changePage}
                        containerClassName={"paginationBttns"}
                        previousLinkClassName={"previousBttn"}
                        nextLinkClassName={"nextBttn"}
                        disabledClassName={"paginationDisabled"}
                        activeClassName={"paginationActive"}
                        pageClassName={'pageClassNamePdf'}
                        pageRangeDisplayed={1}
                        nextLabel={<ArrowRightIcon />}
                        previousLabel={<ArrowLeftIcon />}
                        renderOnZeroPageCount={null}
                    />
                </Grid>
                <Grid item xs={12} md={12} lg={12} xl={12}>
                    <Button variant="contained"
                        color="secondary"
                        endIcon={<DownloadIcon />}
                        onClick={() => handleDownloadPdf(data.contractS3Key)}
                        sx={btnDownload}

                    > Download Contract </Button>
                </Grid>
            </React.Fragment>
        ) : (<div></div>)
    }

    return (
        <React.Fragment>
            {renderContractPdf(props.step1Result)}
            <Grid item xs={12} md={12} lg={12} xl={12}>
                <FormGroup>
                    <FormControlLabel control={<Checkbox onChange={handleClickAgree} />} label="Agree with APOLLO terms" />
                </FormGroup>
            </Grid>
        </React.Fragment>

    );
}